<template>
  <div
    class="customer-details-card"
    :class="[
      {
        'customer-details-card--tall': tall,
        'customer-details-card--full-row': fullRow,
        'customer-details-card--note': variant === 'note',
      },
      customClass,
    ]"
    :style="cardStyle"
  >
    <template v-if="variant === 'note'">
      <div class="customer-details-card__body customer-details-card__body--note">
        <div class="customer-details-card__header customer-details-card__header--note">
          <div class="customer-details-card__title-row">
            <span
              v-if="icon && !iconClass"
              class="customer-details-card__icon customer-details-card__icon--note"
              aria-hidden="true"
            >{{ icon }}</span>
            <i
              v-else-if="iconClass"
              :class="[iconClass, 'customer-details-card__icon', 'customer-details-card__icon--bi', 'customer-details-card__icon--note']"
              aria-hidden="true"
            />
            <div class="customer-details-card__note-title">{{ label }}</div>
          </div>
          <div v-if="$slots.headerActions" class="customer-details-card__header-actions">
            <slot name="headerActions" />
          </div>
        </div>
        <div class="customer-details-card__value customer-details-card__value--note">
          <slot>{{ displayValue }}</slot>
        </div>
      </div>
    </template>
    <template v-else>
      <span v-if="icon && !iconClass" class="customer-details-card__icon" aria-hidden="true">{{ icon }}</span>
      <i
        v-else-if="iconClass"
        :class="[iconClass, 'customer-details-card__icon', 'customer-details-card__icon--bi']"
        aria-hidden="true"
      />
      <div class="customer-details-card__body">
        <div class="customer-details-card__header">
          <div class="customer-details-card__field-label">{{ label }}</div>
          <div v-if="$slots.headerActions" class="customer-details-card__header-actions">
            <slot name="headerActions" />
          </div>
        </div>
        <div class="customer-details-card__value">
          <slot>{{ displayValue }}</slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CustomerDetailsCard',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    emptyText: {
      type: String,
      default: '-',
    },
    tall: {
      type: Boolean,
      default: false,
    },
    /** Span full grid width (email, address, notes). */
    fullRow: {
      type: Boolean,
      default: false,
    },
    animationDelay: {
      type: String,
      default: '',
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
    /** Note list cards — icon and title on one row. */
    variant: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    displayValue() {
      if (this.$slots.default) return '';
      if (this.value === null || this.value === undefined || this.value === '') {
        return this.emptyText;
      }
      return this.value;
    },
    cardStyle() {
      if (!this.animationDelay) return undefined;
      return { '--cdc-delay': this.animationDelay };
    },
  },
};
</script>

<style src="../styles/CustomerDetailsCard.css"></style>
